import React from 'react';
import PropTypes from 'prop-types';
import classNames, { classNamesFor } from '../utils/classNames';
import Image from '../Image';
import Icon from '../Icon';
import ResolveTheme from '../ResolveTheme';

var SubscriptionBenefits = function SubscriptionBenefits(props) {
  var benefits = props.benefits,
      className = props.className,
      qa = props.qa;
  if (!(benefits === null || benefits === void 0 ? void 0 : benefits.length)) return null;

  var _SubscriptionBenefits = SubscriptionBenefits.getClassName({
    className: className
  }),
      root = _SubscriptionBenefits.root,
      listItemClass = _SubscriptionBenefits.listItem,
      textClass = _SubscriptionBenefits.text,
      iconClass = _SubscriptionBenefits.icon;

  return /*#__PURE__*/React.createElement("ul", {
    className: root,
    "data-qa": qa
  }, benefits.map(function (_ref, idx) {
    var id = _ref.id,
        value = _ref.value,
        icons = _ref.icons,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled;
    if (!value) return null;
    return /*#__PURE__*/React.createElement("li", {
      className: classNames(listItemClass, disabled && 'psw-c-t-2'),
      "data-qa": "".concat(qa, "#benefit-").concat(idx),
      key: id
    }, /*#__PURE__*/React.createElement(ResolveTheme, null, function (_ref2) {
      var theme = _ref2.theme;
      var iconObj = icons.find(function (icon) {
        return (icon === null || icon === void 0 ? void 0 : icon.theme) === theme.toUpperCase();
      });
      return !disabled ? /*#__PURE__*/React.createElement(Image, {
        alt: value,
        aspectRatio: "1:1",
        className: iconClass,
        qa: "".concat(qa, "#benefit-icon-").concat(idx),
        src: iconObj === null || iconObj === void 0 ? void 0 : iconObj.url
      }) : /*#__PURE__*/React.createElement(Icon, {
        label: value,
        type: "no-operation-allowed",
        size: "2",
        qa: "".concat(qa, "#benefit-icon-").concat(idx)
      });
    }), /*#__PURE__*/React.createElement("span", {
      className: textClass,
      "data-qa": "".concat(qa, "#benefit-text-").concat(idx)
    }, value));
  }));
};

var cx = classNamesFor(SubscriptionBenefits);

SubscriptionBenefits.getClassName = function (_ref3) {
  var className = _ref3.className;
  return {
    root: cx(className, 'psw-subscription-benefits'),
    listItem: cx('psw-subscription-benefits-list-item', 'psw-l-line-left', 'psw-l-align-top', 'psw-l-space-x-3', 'psw-m-b-3'),
    text: cx('psw-t-subtitle', 'psw-subscription-benefits-text'),
    icon: cx('psw-subscription-benefits-icon')
  };
};

SubscriptionBenefits.defaultProps = {
  qa: '',
  className: ''
};
SubscriptionBenefits.propTypes = {
  /**
   * Array of subscription benefits, each benefit is an object
   */
  benefits: PropTypes.arrayOf(PropTypes.shape({
    /**
     * A unique identifier for the benefit
     */
    id: PropTypes.string,

    /**
     * A translated string describing the benefit
     */
    value: PropTypes.string,

    /**
     * Array of benefit icons supporting light and dark mode
     */
    icons: PropTypes.arrayOf(PropTypes.shape({
      /**
       * Defines type of an icon e.g. IMAGE
       */
      type: PropTypes.string,

      /**
       * A url representing the benfits icon
       */
      url: PropTypes.string,

      /**
       * Icon role e.g. ICON
       */
      role: PropTypes.string,

      /**
       * Icon theme e.g. LIGHT or DARK
       */
      theme: PropTypes.string
    })),

    /**
     * Display benefits as grayed out to demonstrate they are unavailable
     */
    disabled: PropTypes.bool
  })).isRequired,

  /**
   * Allows adding a custom class or series of classes on the component
   */
  className: PropTypes.string,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string
};
export default SubscriptionBenefits;